module.exports = __webpack_public_path__ + "img/icon_map_188_on_011.082cca00.png";